import { render } from "./AddInvoiceImages.vue?vue&type=template&id=12c99208"
import script from "./AddInvoiceImages.vue?vue&type=script&lang=js"
export * from "./AddInvoiceImages.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/var/www/duo_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__